<template>
  <div v-if="value" class="d-flex ga-3 align-center user-info-item">
    <v-icon size="26" color="#BD9478" :icon="icon" />
    <h3 class="key">{{ labelText }}</h3>
    <span class="value">{{ value }}</span>
  </div>
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
    },
    value: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.user-info-item {
  .key {
    font-size: $mediumTextSize;
    font-weight: 700;
  }

  .value {
    font-size: $mediumTextSize;
    color: $DeepGray;
  }
}
</style>
